// src/services/chatbot.service.js
// Cliente del servicio del chatbot (chatbot/servidor.js). A diferencia de
// analysis.service.js, aquí NO hay key: la llamada a Mistral la hace el
// servidor. En producción nginx enruta /chat/ al servicio; en desarrollo lo
// hace el proxy de vue.config.js.
const CHAT_URL = process.env.VUE_APP_CHAT_URL || "/chat/mensaje";

/**
 * Envía la conversación y devuelve la respuesta del asistente.
 * @param {{role: "user"|"assistant", content: string}[]} messages
 * @returns {Promise<{respuesta: string, consultas: string[]}>}
 */
export async function enviarMensaje(messages) {
  const r = await fetch(CHAT_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ messages }),
  });
  let data = null;
  try {
    data = await r.json();
  } catch (e) {
    data = null;
  }
  if (!r.ok) {
    // Sin cuerpo JSON = la respuesta no vino del servicio del chatbot sino del
    // proxy (nginx o el dev server) porque el servicio no está levantado.
    throw new Error(
      (data && data.error) ||
        "El servicio del asistente no está disponible (" + r.status + "). Intenta más tarde."
    );
  }
  return data;
}
